import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	screenReaderText: {
		id: 'project-create-importer-upload-flow.common.step-progress-bar.screen-reader-text',
		defaultMessage: 'Step {currentStepIndex} of {numSteps} {currentStepLabel}',
		description: 'Accessible text calling out step progress bar progress',
	},
});
